import { ChartSetup } from "./enrollment.chart-controller";

var Highcharts = require('highcharts/highcharts');
require('highcharts/highcharts-more')(Highcharts);


export class DrilldownChartBar {
    constructor() {

    }


    UpdateChart(chartSetup: ChartSetup, xAxisLabel: string, yAxisLabel: string, xLabels: string[]): void {
        Highcharts.chart('total-enrollment-modal-chart', {
            chart: {
                type: 'bar',
            },
            credits: { enabled: false },
            title: { text: null },
            xAxis: {
                tickInterval: 1,
                title: { text: xAxisLabel },
                labels: {
                    formatter: function () {
                        return xLabels[this.value];
                    },
                    allowOverlap: true
                }
            },
            yAxis: {
                title: { text: yAxisLabel }
            },
            plotOptions: {
                bar: {
                    stacking: "normal"
                }
            },
            series: chartSetup.series
        });
    }
}